import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setLocalLogout } from '../../redux/slices/loginSlice';
import { getAdminTokenApi, getChildGroups, getGroupByName, getUserGroups, refreshAuthToken } from '../../utils/AuthUtil';
import { toast } from 'react-toastify';

const CheckUserStatus = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [adminToken, setAdminToken] = useState(null);
  const [adminTokenExpiry, setAdminTokenExpiry] = useState(null);

  const getAdminToken = async () => {
    let token: any;
    await getAdminTokenApi().then((adminToken) => {

      setAdminToken(adminToken.token);
      setAdminTokenExpiry(adminToken.expiryTime);
  
      token = adminToken.token;
    });
    return token;
  };
 
  const checkUserStatus = async (userId: any, token: any) => {
    try {
      // Fetch user groups
      const userGroups = await getUserGroups(userId, token);
      
      // Check if the user is in both Employee Group and Grievance Group
      const isInEmployeeGroup = userGroups.some((group: any) => group.name === 'Employee Group');
      const isInGrievanceGroup = userGroups.some((group: any) => group.name === 'Grievance');
      
      if (isInEmployeeGroup && isInGrievanceGroup) {
        // Find the Grievance group within the user's groups
        const grievanceGroup = userGroups.find((group: any) => group.name === 'Grievance');
        if (grievanceGroup) {
          // Fetch the subgroups of the Grievance Group
          const grievanceSubGroups = await getChildGroups(grievanceGroup.id, token);
          // Check if the user is in any of the subgroups of the Grievance Group
          const isInGrievanceSubGroup = grievanceSubGroups.some((subGroup: any) => userGroups.some((group: any) => group.id === subGroup.id));
          
          if (isInGrievanceSubGroup) {
            return false; // User is enabled
          } else {
            return true; // User is disabled
          }
        }
      }
      
      // If the user is not in both Employee Group and Grievance Group, consider as disabled
      return true;
    } catch (error) {
      console.error('Error checking user status:', error);
      toast.error('User does not have permissions. please contact the admin');
      await logout();
      return false; // or throw error;
    }
  }
  
  const sessionCheck = async (sessionId: any, userId: any, token: any) => {
    const sessionsResponse = await axios.get(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/users/${userId}/sessions`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    const sessions = sessionsResponse.data;
    for (const session of sessions) {
      if (session?.id === sessionId) {
        return false;
      }
    }
    return true;
  }

  const logout = async () => {
    const appAuth = JSON.parse(localStorage.getItem('app-auth') || '{}');
    const refreshToken = appAuth?.resetToken;

    if (refreshToken) {
      await fetch(`${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          'client_id': process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? '',
          'client_secret': process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET ?? '',
          'refresh_token': refreshToken
        })
      });
    }

    localStorage.clear();
    dispatch(setLocalLogout({}));
    navigate('/login');
  };

  
  useEffect(() => {
    const interval = setInterval(async () => {
      const appAuth = JSON.parse(localStorage.getItem('app-auth') || '{}');
      const { accessToken, resetToken, userId, sessionId } = appAuth;

      if (accessToken && userId) {
        try {
          let token = adminToken;
          const currentTime = Math.floor(Date.now() / 1000);

          if (!token || (adminTokenExpiry && currentTime >= adminTokenExpiry)) {
            token = await getAdminToken();
          }

          // const isDisabled = await checkUserStatus(userId, token);
          let isCurrentSessionDeleted = await sessionCheck(sessionId, userId, token);

          // if (isDisabled) {
          //   // Force logout
          //   toast.error('User does not have permissions. please contact the admin')
          //   await logout();
          // }
          // else {
            // Check if the token is about to expire and refresh it
            const tokenPayload = JSON.parse(atob(accessToken.split('.')[1]));
            if (tokenPayload.exp - currentTime < 60) {
              const newAccessToken = await refreshAuthToken(resetToken, dispatch);
              let appAuth = JSON.parse(localStorage.getItem('app-auth') ?? '');
              isCurrentSessionDeleted = await sessionCheck(appAuth.sessionId, appAuth?.userId, token);
            }
          // }
          if (isCurrentSessionDeleted){
            toast.error('Session expired');
            await logout();
          }
        } catch (error) {
          console.error('Error checking user status:', error);
        }
      }
    }, 10000); // Check every 10 seconds

    return () => clearInterval(interval);
  }, [navigate, dispatch, adminToken, adminTokenExpiry]);

  return null;
};
export default CheckUserStatus;
